import React from "react";
import "./terms.css";
import { Link } from "react-router-dom";

export default function AccessibilityStatement() {
  return (
<main dir="rtl" lang="he" className="container legal-page" role="main">
      <a href="#content" className="sr-only-focusable">דלג לתוכן</a>
      <div id="a11y-title">הצהרת נגישות</div>
            <div className="logo-container-sign">
        <Link to="/">
          <img src="/icons/green-logo.png" alt="Logo" className="logo" />
        </Link>
      </div>

      <section id="content" aria-labelledby="about-a11y">
        <h2 id="about-a11y">מחויבות לנגישות</h2>
        <p>
          אנו ב-Heyi מחויבים להנגשת האתר והאפליקציה לכלל המשתמשים, לרבות אנשים עם מוגבלות,
          ופועלים בהתאם לתקנות שוויון זכויות לאנשים עם מוגבלות (שירותים מקוונים).
        </p>
      </section>

      <section aria-labelledby="conformance">
        <h2 id="conformance">רמת התאמה</h2>
        <p>השירות שואף לעמידה ב-WCAG 2.1 רמה AA.</p>
      </section>

      <section aria-labelledby="measures">
        <h2 id="measures">התאמות שבוצעו</h2>
        <ul>
          <li>תמיכה בקוראי מסך, שימוש ב-ARIA ותיוג אלמנטים משמעותיים.</li>
          <li>ניווט מלא באמצעות מקלדת וסדר מיקוד (Tab) תקין.</li>
          <li>ניגודיות צבעים מספקת וניתן להגדלת טקסט עד 200% ללא פגיעה בפריסה.</li>
          <li>טקסט חלופי (alt) לתמונות ותוויות (labels) לשדות וקישורים.</li>
          <li>מבנה כותרות היררכי, אזורי landmark (header/main/nav/footer).</li>
        </ul>
      </section>

      <section aria-labelledby="limits">
        <h2 id="limits">חריגות ידועות</h2>
        <p>
          ייתכנו אזורים או רכיבים שעדיין בתהליך שיפור. אנו משפרים באופן מתמשך לפי משוב משתמשים.
        </p>
      </section>

      <section aria-labelledby="contact">
        <h2 id="contact">פניות ובקשות נגישות</h2>
        <p>
          נתקלת בקושי? נשמח לסייע. כתבו לנו:
          <br/>מייל: <a href="mailto:heyi.events@gmail.com">heyi.events@gmail.com</a>
          <br/>טלפון: <a href="tel:+972542001485">054-2001485</a>
          <br/>אחראי נגישות: יוסף גבריאל
        </p>
        <p>תאריך עדכון אחרון: 10.09.2025</p>
      </section>
    </main>
  );
}
